"use client"

import { useEffect } from 'react'

export default function HubspotMeetingsEmbed({ url, minHeight = 720 }: { url: string; minHeight?: number }) {
  useEffect(() => {
    const id = 'hubspot-meetings-embed-script'
    if (document.getElementById(id)) return
    const script = document.createElement('script')
    script.id = id
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    document.body.appendChild(script)
  }, [])

  return <div className="meetings-iframe-container" data-src={url} style={{ minHeight }} />
}
